import { Button } from '@openx/components-core/lib/Button/Button.tsx';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

export type DealIdGroupCreateButtonProps = {
  dealId?: string;
};

export const DealIdGroupCreateButton = ({ dealId }: DealIdGroupCreateButtonProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Button
      onClick={() =>
        navigate('/deals/create', {
          state: {
            externalDealId: dealId,
          },
        })
      }
      color="primary"
      data-test="create-deal-within-group"
    >
      {t('Create deal within group')}
    </Button>
  );
};
